import React, { useCallback, useEffect, useState, lazy, memo, Component } from 'react';
import { ChevronRightIcon, ChevronLeftIcon, ChevronRightIcon as NextIcon } from 'lucide-react';
// Componente de imagen optimizado con lazy loading
const LazyImage = memo(({
  src,
  alt,
  className,
  isVisible
}) => {
  const [loaded, setLoaded] = useState(false);
  return <img src={isVisible ? src : ''} data-src={src} alt={alt} className={`${className} ${loaded ? 'opacity-100' : 'opacity-0'}`} style={{
    transition: 'opacity 0.3s'
  }} onLoad={() => setLoaded(true)} loading="lazy" data-id="element-189" />;
});
export function Hero() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const images = [{
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/ryaRXjr8Y9sxzqnkd8jxaA/ChatGPT_Image_Sep_11%2C_2025%2C_03_13_38_PM.png',
    alt: 'Libro de 20 Cenas Listas en 15 Minutos'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/hWYzf9qG5NZun4tjSm6m3M/Generated_Image_September_11%2C_2025_-_5_22PM.png',
    alt: 'Colección de libros de recetas'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/urnT29816pGj1yprXnxsFi/Generated_Image_September_11%2C_2025_-_3_17PM.png',
    alt: 'Mamá cocinando con su hija'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/7AXg44yfDYr9grKTsUgcAT/Generated_Image_September_11%2C_2025_-_3_16PM.png',
    alt: 'Mamá cocinando con el libro de recetas'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/k64zobWUZdwfjnkEVRpj81/Generated_Image_September_11%2C_2025_-_3_18PM.png',
    alt: 'Libro de 20 Cenas Listas en 15 Minutos'
  }];
  const nextSlide = useCallback(() => {
    setCurrentIndex(prevIndex => prevIndex === images.length - 1 ? 0 : prevIndex + 1);
  }, [images.length]);
  const prevSlide = useCallback(() => {
    setCurrentIndex(prevIndex => prevIndex === 0 ? images.length - 1 : prevIndex - 1);
  }, [images.length]);
  // Auto rotate slides every 3 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      nextSlide();
    }, 3000);
    return () => clearInterval(interval);
  }, [nextSlide]);
  // Precarga la imagen actual y la siguiente
  const getIsVisible = index => {
    return index === currentIndex || index === (currentIndex + 1) % images.length || index === (currentIndex - 1 + images.length) % images.length;
  };
  return <section className="w-full bg-gradient-to-b from-amber-50 to-amber-100 py-12 md:py-20" data-id="element-190">
      <div className="container mx-auto px-4 md:px-8" data-id="element-191">
        <div className="flex flex-col md:flex-row items-center gap-8 md:gap-12" data-id="element-192">
          <div className="flex-1 text-center md:text-left" data-id="element-193">
            <h1 className="text-3xl md:text-5xl font-bold text-amber-800 mb-4" data-id="element-194">
              20 Cenas Listas en 15 Minutos ✨
            </h1>
            <h2 className="text-xl md:text-2xl text-amber-700 mb-6" data-id="element-195">
              Recetas sin horno para mamás ocupadas
            </h2>
            <p className="text-amber-900 mb-8 max-w-xl mx-auto md:mx-0" data-id="element-196">
              No es que no sepas cocinar. Es que ya no te queda tiempo ni
              energía. Y aun así, todos los días, alguien te mira con hambre y
              la misma pregunta: "¿Qué hay de cenar, mamá?"
            </p>
            <a href="https://productivetips.com/cart/45129127657658:1?checkout" className="bg-amber-700 hover:bg-amber-800 text-white font-medium py-3 px-8 rounded-lg shadow-md text-lg flex items-center mx-auto md:mx-0 transition duration-300" data-id="element-197">
              <span data-id="element-198">Comprar ahora - Solo $9.97</span>
            </a>
            <p className="mt-2 text-amber-700 text-sm font-medium mx-auto md:mx-0" data-id="element-199">
              <span className="line-through" data-id="element-200">$29.91</span> • Ahorras $19.94
            </p>
          </div>
          <div className="flex-1 mt-8 md:mt-0" data-id="element-201">
            {/* Desktop image - hidden on mobile */}
            <div className="hidden md:block" data-id="element-202">
              <LazyImage src="https://uploadthingy.s3.us-west-1.amazonaws.com/ryaRXjr8Y9sxzqnkd8jxaA/ChatGPT_Image_Sep_11%2C_2025%2C_03_13_38_PM.png" alt="Libro de 20 Cenas Listas en 15 Minutos" className="w-full max-w-md mx-auto rounded-lg shadow-lg" isVisible={true} data-id="element-203" />
            </div>
            {/* Mobile carousel - only visible on mobile */}
            <div className="md:hidden relative" data-id="element-204">
              <div className="overflow-hidden rounded-lg shadow-lg" data-id="element-205">
                <div className="relative" data-id="element-206">
                  {images.map((image, index) => <div key={index} className={`absolute inset-0 transition-opacity duration-300 ${currentIndex === index ? 'opacity-100 z-10' : 'opacity-0 z-0'}`} aria-hidden={currentIndex !== index} data-id="element-207">
                      <LazyImage src={image.src} alt={image.alt} className="w-full rounded-lg" isVisible={getIsVisible(index)} data-id="element-208" />
                    </div>)}
                  {/* Navigation buttons */}
                  <button onClick={prevSlide} className="absolute left-2 top-1/2 -translate-y-1/2 bg-white/70 p-2 rounded-full shadow-md z-20" aria-label="Imagen anterior" data-id="element-209">
                    <ChevronLeftIcon className="h-5 w-5 text-amber-800" data-id="element-210" />
                  </button>
                  <button onClick={nextSlide} className="absolute right-2 top-1/2 -translate-y-1/2 bg-white/70 p-2 rounded-full shadow-md z-20" aria-label="Siguiente imagen" data-id="element-211">
                    <NextIcon className="h-5 w-5 text-amber-800" data-id="element-212" />
                  </button>
                </div>
              </div>
              {/* Dots indicator */}
              <div className="flex justify-center mt-4 space-x-2" data-id="element-213">
                {images.map((_, index) => <button key={index} onClick={() => setCurrentIndex(index)} className={`w-2 h-2 rounded-full ${currentIndex === index ? 'bg-amber-600' : 'bg-amber-300'}`} aria-label={`Ir a imagen ${index + 1}`} data-id="element-214" />)}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}